"use client";
import React from "react";

import { Box, BoxDiv, BoxSx, ThemeColors } from "../../foundations";

export type DividerProps = {
  color?: ThemeColors;
  direction?: "horizontal" | "vertical";
  size?: "small" | "medium" | "large";
} & BoxDiv;

const dividerSizes = {
  small: "1px",
  medium: "2px",
  large: "4px"
};

export const Divider: React.FC<DividerProps> = ({
  color,
  direction = "horizontal",
  size = "small",
  sx
}) => {
  const dividerStyles: BoxSx = {
    borderColor: color ? color : "stroke-neutral-default",
    borderStyle: "solid",
    display: "block",
    transition: "transition-color-medium",
    ...(direction === "horizontal"
      ? {
          borderWidth: `${dividerSizes[size]} 0 0 0`,
          width: "100%",
          height: "auto"
        }
      : {
          borderWidth: `0 0 0 ${dividerSizes[size]}`,
          height: "100%",
          width: "auto"
        })
  };

  const computedAs = direction === "horizontal" ? "hr" : "div";

  return (
    <Box
      as={computedAs}
      sx={{
        ...dividerStyles,
        ...sx
      }}
    />
  );
};
